import { __extends } from "tslib";
import { NodeMaterialBlock } from '../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../Misc/typeStore';
/**
 * Operations supported by the Wave block
 */
export var WaveBlockKind;
(function (WaveBlockKind) {
    /** SawTooth */
    WaveBlockKind[WaveBlockKind["SawTooth"] = 0] = "SawTooth";
    /** Square */
    WaveBlockKind[WaveBlockKind["Square"] = 1] = "Square";
    /** Triangle */
    WaveBlockKind[WaveBlockKind["Triangle"] = 2] = "Triangle";
})(WaveBlockKind || (WaveBlockKind = {}));
/**
 * Block used to apply wave operation to floats
 */
var WaveBlock = /** @class */ (function (_super) {
    __extends(WaveBlock, _super);
    /**
     * Creates a new WaveBlock
     * @param name defines the block name
     */
    function WaveBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;
        /**
         * Gets or sets the kibnd of wave to be applied by the block
         */
        _this.kind = WaveBlockKind.SawTooth;
        _this.registerInput("input", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
        _this._outputs[0]._typeConnectionSource = _this._inputs[0];
        _this._inputs[0].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Matrix);
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    WaveBlock.prototype.getClassName = function () {
        return "WaveBlock";
    };
    Object.defineProperty(WaveBlock.prototype, "input", {
        /**
         * Gets the input component
         */
        get: function () {
            return this._inputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WaveBlock.prototype, "output", {
        /**
         * Gets the output component
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    WaveBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        var output = this._outputs[0];
        switch (this.kind) {
            case WaveBlockKind.SawTooth: {
                state.compilationString += this._declareOutput(output, state) + (" = " + this.input.associatedVariableName + " - floor(0.5 + " + this.input.associatedVariableName + ");\r\n");
                break;
            }
            case WaveBlockKind.Square: {
                state.compilationString += this._declareOutput(output, state) + (" = 1.0 - 2.0 * round(fract(" + this.input.associatedVariableName + "));\r\n");
                break;
            }
            case WaveBlockKind.Triangle: {
                state.compilationString += this._declareOutput(output, state) + (" = 2.0 * abs(2.0 * (" + this.input.associatedVariableName + " - floor(0.5 + " + this.input.associatedVariableName + "))) - 1.0;\r\n");
                break;
            }
        }
        return this;
    };
    WaveBlock.prototype.serialize = function () {
        var serializationObject = _super.prototype.serialize.call(this);
        serializationObject.kind = this.kind;
        return serializationObject;
    };
    WaveBlock.prototype._deserialize = function (serializationObject, scene, rootUrl) {
        _super.prototype._deserialize.call(this, serializationObject, scene, rootUrl);
        this.kind = serializationObject.kind;
    };
    return WaveBlock;
}(NodeMaterialBlock));
export { WaveBlock };
_TypeStore.RegisteredTypes["BABYLON.WaveBlock"] = WaveBlock;
//# sourceMappingURL=waveBlock.js.map